export default __webpack_public_path__ + "static/media/blog-featured-image-mls.c7b52d17.png";